import { SelectOptionType } from 'utils/react-table';

type ContactTypeDto = {
    id?: number | null;
    name: string;
};

export const mapContactTypeToSelectOption = (types: Array<ContactTypeDto>): Array<SelectOptionType> => {
    return types.map((type) => ({ value: type.id ?? 0, label: type.name }));
};

export default ContactTypeDto;
